export const ALL_SPECIAL_PRICES_FORM_MODAL = "ALL_SPECIAL_FORM_PRICES";
